import React, { createContext } from 'react';
import { ObsoleteServicesBySimulation } from '../helpers/hooks/simulation';

type ContextType = {
    data: ObsoleteServicesBySimulation;
    isLoading: boolean;
};
const HistoricalOrgChartHrContext: React.Context<ContextType> =
    createContext<ContextType>({ isLoading: false, data: {} });

export default HistoricalOrgChartHrContext;
